import { moment } from "../utils/moment.service"

/**
 * Remove a soft deletable from an array of instances.
 * Depending on the persistance in database, the processing slightly differs.
 * If the object already exists in database, a _destroy=true or deleted_at=now must be set.
 * Else, the object can simply be removed from the array.
 */
export function modelRemoveSoftDeletableFromArray<
  T extends { id?: number } & { [property in U]?: U extends '_destroy' ? boolean : string },
  U extends '_destroy' | 'deleted_at'
> (array: T[], instance: T, property: U, comparator = (a: T, b: T) => a === b || (a.id && b.id && a.id === b.id)): T[] {
  if (!instance.id) return array.filter(_ => !comparator(_, instance))
  return array.map(_ => comparator(_, instance) ? { ..._, [property]: property === '_destroy' ? true : moment().format('YYYY-MM-DD HH:mm:ss') } : _)
}

/**
 * Add a soft deletable to an array of instances.
 * If an object in the array was masked for deletion, but as not yet been deleted, it can be restored.
 * Else, a new instance should be added to the array.
 */
export function modelAddSoftDeletableToArray<
  T extends { id?: number } & { [property in U]?: U extends '_destroy' ? boolean : string },
  U extends '_destroy' | 'deleted_at'
> (array: T[], instance: T, property: U, comparator: (a: T, b: T) => boolean): T[] {
  const existingInstance = array.find(_ => comparator(_, instance))
  if (existingInstance) return array.map(_ => comparator(_, existingInstance) ? { ..._, [property]: property === '_destroy' ? false : null } : _)
  return array.concat(instance)
}

export function modelToogleSoftDeletable<
  T extends { id?: number } & { [property in U]?: U extends '_destroy' ? boolean : string },
  U extends '_destroy' | 'deleted_at'
> (array: T[], instance: T, property: U, comparator: (a: T, b: T) => boolean): T[] {
  const activeInArray = array.find(_ => comparator(_, instance) && !_[property])
  return (activeInArray ? modelRemoveSoftDeletableFromArray : modelAddSoftDeletableToArray)(array, activeInArray || instance, property, comparator)
}
